export default "__VITE_ASSET__jSCPTXWp__"